import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "@phosphor-icons/react";
import { useConcierge } from "@/context/ConciergeContext";
import { useI18n } from "@/context/I18nContext";
import { NAP } from "@/data/site";
import { track } from "@/lib/api";
import { Reveal } from "@/components/Reveal";

export function CTASection({ title, subtitle }) {
  const { openConcierge } = useConcierge();
  const { t } = useI18n();
  const heading = title || t("cta.title");
  const sub = subtitle || t("cta.subtitle");
  return (
    <section className="relative border-t border-border overflow-hidden grain" data-testid="cta-section">
      <div className="absolute inset-0 blueprint-grid opacity-40" />
      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8 py-20 lg:py-28 text-center">
        <Reveal as="h2" className="font-display uppercase tracking-tight text-3xl sm:text-5xl lg:text-6xl leading-[0.95] max-w-3xl mx-auto text-balance">
          {heading}
        </Reveal>
        <Reveal delay={100} className="mt-5 text-muted-foreground text-base sm:text-lg max-w-xl mx-auto">
          {sub}
        </Reveal>
        <Reveal delay={180} className="mt-9 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/contact"
            onClick={() => track("cta_click", { cta: "free_quote", location: "cta_section" })}
            data-testid="cta-quote"
            className="group inline-flex items-center justify-center gap-3 bg-primary text-primary-foreground font-mono-tech text-xs tracking-widest uppercase px-8 h-14 hover:bg-[hsl(16,100%,55%)] transition-colors"
          >
            {t("act.getFreeQuote")}
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </Link>
          <button
            onClick={() => {
              track("cta_click", { cta: "open_concierge", location: "cta_section" });
              openConcierge();
            }}
            data-testid="cta-concierge"
            className="inline-flex items-center justify-center gap-3 border border-border text-foreground font-mono-tech text-xs tracking-widest uppercase px-8 h-14 hover:border-primary hover:text-primary transition-colors"
          >
            {t("act.instantEstimate")}
          </button>
          <a
            href={`tel:${NAP.phoneHref}`}
            onClick={() => track("click_to_call", { location: "cta_section" })}
            data-testid="cta-call"
            className="inline-flex items-center justify-center gap-3 border border-border text-foreground font-mono-tech text-xs tracking-widest uppercase px-8 h-14 hover:border-primary hover:text-primary transition-colors"
          >
            <Phone size={16} /> {NAP.phoneDisplay}
          </a>
        </Reveal>
      </div>
    </section>
  );
}
